/**
 * Generated from ch9_p04.fla
 */
export function ch9_p04(this: Ich9_p04) {
	const bg = this.bg;
	ch9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const holly = this.holly;
	ch9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_holly.call(this.holly);
	holly.x = 1141.5;
	holly.y = 768;
	holly.width = 438.00;
	holly.height = 710.50;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const lanterns = this.lanterns;
	ch9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_lanterns.call(this.lanterns);
	lanterns.x = 577;
	lanterns.y = 624.5;
	lanterns.width = 495.00;
	lanterns.height = 287.00;
	lanterns.alpha = 1.00;
	if (lanterns.onLayout) lanterns.onLayout();
	const frameRight = this.frameRight;
	ch9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 351.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 345.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_bg(this: Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p04_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_holly(this: Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p04_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_lanterns(this: Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_lanterns) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp9_p04_lanterns", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_wcframeRframe(this: Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_wcframeLframe(this: Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich9_p04Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich9_p04Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich9_p04Sprite extends Ich9_p04Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich9_p04Text extends Ich9_p04Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich9_p04Polygon extends Array<number> {
}
interface Ich9_p04 {
	readonly bg: Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_bg;
	readonly holly: Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_holly;
	readonly lanterns: Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_lanterns;
	readonly frameRight: Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_wcframeRframe;
	readonly frameLeft: Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_wcframeLframe;
}
interface Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_bg extends Ich9_p04Sprite {
}
interface Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_holly extends Ich9_p04Sprite {
}
interface Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_lanterns extends Ich9_p04Sprite {
}
interface Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_wcframeRframe extends Ich9_p04Sprite {
}
interface Ich9_p04_hh_ch9_72dpi_p04psdAssetchp9_p04_wcframeLframe extends Ich9_p04Sprite {
}
